import { i18n as _i18n } from "@lingui/core";
import { CarleadCreationButton, CarleadCreationForm, CarleadLicensePlateNotRecognized, CarleadMileageFormatted, defaultCarleadSplitFlow, Email, PricedCarsCounter, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitBuiltDates, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypes, SplitMainTypesSub, SplitManufacturers, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useCreateNormalCarleadForm, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps } from '@wkda/carlead-creation-components';
import cx from 'classnames';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { CarleadProgress, TrustPilot } from '../../../../../components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadStepCompoundCustomerCounter = _ref => {
  let {
    wide = false,
    className = '',
    emailSubtitle = false
  } = _ref;
  const questionnaireProps = useFormQuestionnaireProps(defaultCarleadSplitFlow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(defaultCarleadSplitFlow);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useCreateNormalCarleadForm([questionnaireProps, splitFieldsProps]);
  useTrackLanding();
  return /*#__PURE__*/_jsx(Paper, {
    className: "carlead-creation-form__container step-compound",
    children: /*#__PURE__*/_jsx("div", {
      className: "box gap full-height " + className,
      children: /*#__PURE__*/_jsxs("div", {
        className: cx('container', {
          'container-xl': wide
        }),
        children: [/*#__PURE__*/_jsx(CarleadLicensePlateNotRecognized, {}), /*#__PURE__*/_jsx(PricedCarsCounter, {}), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          options: {
            name: 'StepCompound'
          },
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(SplitManufacturers, {}), /*#__PURE__*/_jsx(SplitMainTypes, {}), /*#__PURE__*/_jsx(SplitBuiltDates, {}), /*#__PURE__*/_jsx(SplitBodyTypes, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitFuelType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitHorsePower, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitGearType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitDoorCount, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 2500,
            upperThreshold: 35000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), emailSubtitle ? /*#__PURE__*/_jsx(Email, {
            isHiddenField: true,
            renderFieldWrapper: params => {
              const {
                headerRenderer,
                fieldRenderer,
                belowRenderer,
                name,
                infoText
              } = params;
              return /*#__PURE__*/_jsxs("div", {
                className: "carlead-creation-field",
                children: [headerRenderer({
                  label: params.label,
                  name
                }), /*#__PURE__*/_jsx("p", {
                  className: "carlead-creation-field__email-subtitle",
                  children: _i18n._(
                  /*i18n*/
                  {
                    id: 'carleadCreation.form.emailpage.text'
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "carlead-creation-field__group",
                  children: [fieldRenderer({
                    name,
                    ...params.extraProps,
                    ...params
                  }), belowRenderer({
                    name,
                    text: infoText
                  })]
                })]
              });
            }
          }) : /*#__PURE__*/_jsx(Email, {
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(CarleadProgress, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "desktop"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              type: "lead",
              screen: "mobile"
            })
          })]
        })]
      })
    })
  });
};
export default CarleadStepCompoundCustomerCounter;